<template>
  <div class="range-filter" @keyup.enter="confirm">
    <div class="filter-title">{{ title }}</div>

    <div class="range-filter-inputs">
        <UiInputText
          v-model="$v.start.$model"
          static-placeholder
          placeholder="C"
          type="text"
          class="range-filter-inputs_input"
        />
      
      <UiInputText
        v-model="$v.end.$model"
        static-placeholder
        placeholder="По"
        type="text"
        class="range-filter-inputs_input"
      />
    </div>

    <div class="filter-operation">
      <UiButton :disabled="$v.$invalid " :class="['range-filter-button','button', 'is-small', 'is-blue']" @click="confirm"> Применить</UiButton>
      <UiButton :class="['range-filter-button', 'button', 'is-small', 'is-light']" @click="reset"> Очистить </UiButton>
    </div>
  </div>
</template>

<script>
import common from './common'
import {requiredIf, decimal} from 'vuelidate/lib/validators'
import validationHelpers from '@/mixins/validationHelpers.js'

export default {
  components: {
    UiInputText: () => import('@/components/UiInputText.vue'),
    UiButton: () => import('@/components/UiButton.vue'),
  },
  mixins: [common,validationHelpers],
  data() {
    return {
      start: '',
      end: '',
    }
  },
  validations: {
    start:{
      required: requiredIf(function(){
        return !this.end 
      }), decimal
    },
    end:{
      required: requiredIf(function(){
        return !this.start 
      }), decimal
    }
  },
  computed: {
    keyStart() {
      return this.queryKey + '_start'
    },
    keyEnd() {
      return this.queryKey + '_end'
    },
  },
  watch: {
    '$route.query': {
      handler: 'setQueryRange',
      immediate: true,
    },
  },
  methods: {
    reset() {
      this.updateQueryParams({
        query: {
          ...this.$query,
          page: null,
          [this.keyStart]: null,
          [this.keyEnd]: null,
        },
      })

      this.closeFn()
    },

    confirm() {
      this.updateQueryParams({
        query: {
          ...this.$query,
          page: null,
          [this.keyStart]: this.start,
          [this.keyEnd]: this.end,
        },
      })

      this.closeFn()
    },

    setQueryRange() {
      this.start = this.$query[this.keyStart]
      this.end = this.$query[this.keyEnd]
    },
  },
}
</script>

<style lang="scss" scoped>
.range-filter {
  &-inputs {
    @include createFlex(flexbox, nowrap, row, flex-start, center, center);
    &_input {
      width: 100px;

      &:first-child {
        margin: 0 rem(8px) 0 0;
      }
    }
   
  }

   &-button {
      width: 100px;

    }

}
</style>
